module.exports = __webpack_public_path__ + "img/ContentPasteSearchOutlined.f7e6ade6.svg";